import { motion } from 'framer-motion';
import { Badge } from '@/components/ui/badge';
import { Lock } from 'lucide-react';

const projects = [
  {
    title: 'Water Infrastructure Modernization Program',
    client: 'Utility / Government Agency',
    scope: 'Managed deployment of 102,000+ smart water meters. Coordinated field teams, logistics, and customer communication. Implemented mobile workforce tracking (ProField).',
    tags: ['Smart Meters', 'Field Operations', 'ProField'],
  },
  {
    title: 'Enterprise Digital Enablement Platform',
    client: 'Telecom',
    scope: 'Delivered 106+ user stories supporting billing and service APIs. Integrated TM-Forum Open APIs for enterprise service delivery. Supported CAB approvals via ServiceNow.',
    tags: ['TM-Forum APIs', 'ServiceNow', 'Billing'],
  },
  {
    title: 'Cloud Financial Transformation',
    client: 'Banking',
    scope: 'Supported Oracle Cloud Financials & EPM implementation. Facilitated Agile ceremonies across multiple financial workstreams. Delivered reporting insights using JIRAs.',
    tags: ['Oracle Cloud', 'EPM', 'Agile'],
  },
  {
    title: 'Logistics & Data Security Initiatives',
    client: 'Enterprise',
    scope: 'Led Sensitive Data Masking & Disaster Recovery Migration. Coordinated across 600+ operational sites. Improved compliance posture and systems resilience.',
    tags: ['Data Masking', 'Disaster Recovery', '600+ Sites'],
  },
];

export default function PastPerformance() {
  return (
    <section
      id="past-performance"
      data-testid="past-performance-section"
      className="py-24 lg:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
            Track Record
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4">
            Past Performance
          </h2>
          <p className="font-body text-sm text-[#737373] flex items-center gap-2">
            <Lock className="h-3 w-3" />
            Details available under NDA upon request
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {projects.map((project, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`performance-card-${i}`}
              className="p-6 bg-[#141414] border border-[#2A2A2A] rounded-lg hover:border-[#B8102E]/30 transition-all duration-300"
            >
              <p className="font-body text-xs text-[#B8102E] tracking-wider uppercase mb-3">
                {project.client}
              </p>
              <h3 className="font-heading text-lg font-semibold text-white mb-3">
                {project.title}
              </h3>
              <p className="font-body text-sm text-[#A3A3A3] leading-relaxed mb-4">
                {project.scope}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {project.tags.map((tag) => (
                  <Badge
                    key={tag}
                    variant="outline"
                    className="text-[10px] text-[#737373] border-[#2A2A2A] bg-transparent font-body"
                  >
                    {tag}
                  </Badge>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
